import { SectionTitleProps } from './props';

export const SectionTitle: React.FC<SectionTitleProps> = (props) => {
  const { title, subItem, containerProps, titleProps, children } = props;

  return (
    <div>
      <div className="section-title-container">
        <div
          style={{
            paddingLeft: 8,
            borderLeft: '8px solid #1E242F',
            ...containerProps,
          }}
        >
          {typeof title === 'string' ? (
            <p
              className="section-title-text"
              style={{
                ...titleProps,
              }}
            >
              {title}
            </p>
          ) : (
            title
          )}
        </div>
        {subItem}
      </div>
      {children}
    </div>
  );
};
